import React, { forwardRef } from 'react'
import { PopoverPaper } from '@mui/material'

const DropdownSearchPaper = forwardRef(({ search, children, ...paperProps }, ref) => (
  <PopoverPaper ref={ref} {...paperProps}>
    {search}
    {children}
  </PopoverPaper>
))

export default DropdownSearchPaper
